import {
  IDmMucHoTroNhaNuoc,
  IDmMucHoTroNhaNuocCopyRequest,
  IDmMucHoTroNhaNuocSelectRequest,
} from "../../../model/respone/category/IDmMucHoTroNhaNuoc";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmMucHoTroNhaNuocActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: {} as IDmMucHoTroNhaNuocSelectRequest,
  LOAD_SUCCESS: {} as IDmMucHoTroNhaNuoc[],
  LOAD_ERROR: "",

  /** Lưu CẢ LƯỚI một lượt; số tiền <= 0 = bỏ thiết lập của phạm vi đó. */
  SAVE_MULTIPLE_START: {} as IDmMucHoTroNhaNuoc[],
  /** Các dòng VỪA LƯU (đúng payload đã gửi) — reducer gộp vào danh sách, khỏi phải nạp lại. */
  SAVE_MULTIPLE_SUCCESS: [] as IDmMucHoTroNhaNuoc[],
  SAVE_MULTIPLE_ERROR: "",

  /** Sao chép mức hỗ trợ từ kỳ khác sang kỳ đang xem. */
  SHOWHIDE_COPY_MODAL: true,
  COPY_CHANGE_REQUEST: {} as IDmMucHoTroNhaNuocCopyRequest,
  COPY_START: {} as IDmMucHoTroNhaNuocCopyRequest,
  COPY_SUCCESS: 0,
  COPY_ERROR: "",

  CHANGE_REQUEST: {} as IDmMucHoTroNhaNuocSelectRequest,
  CHANGE_MODE: 0,
  SET_EXPANDED_KEYS: [] as string[],
};

export const eDmMucHoTroNhaNuocActionIds = generateActionTypeIds(
  eDmMucHoTroNhaNuocActionsObj,
  "MUC_HO_TRO_NHA_NUOC",
);
export type IDmMucHoTroNhaNuocActionTypes = IGenericActionType<
  typeof eDmMucHoTroNhaNuocActionsObj,
  "MUC_HO_TRO_NHA_NUOC"
>;
